import { render, staticRenderFns } from "./GroupCreateDialog.vue?vue&type=template&id=7a1d503b&scoped=true"
import script from "./GroupCreateDialog.vue?vue&type=script&lang=ts"
export * from "./GroupCreateDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a1d503b",
  null
  
)

export default component.exports